
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Plus, X } from 'lucide-react';

interface InvitationFormProps {
  formData: {
    inviterName: string;
    inviterEmail: string;
    emails: string[];
  };
  onFormDataChange: (data: {
    inviterName: string;
    inviterEmail: string;
    emails: string[];
  }) => void;
  onSubmit: () => void;
  isProcessing: boolean;
}

export const InvitationForm = ({
  formData,
  onFormDataChange,
  onSubmit,
  isProcessing
}: InvitationFormProps) => {
  const addEmailField = () => {
    if (formData.emails.length < 10) {
      onFormDataChange({
        ...formData,
        emails: [...formData.emails, '']
      });
    }
  };

  const removeEmailField = (index: number) => {
    onFormDataChange({
      ...formData,
      emails: formData.emails.filter((_, i) => i !== index)
    });
  };

  const handleEmailChange = (index: number, value: string) => {
    onFormDataChange({
      ...formData,
      emails: formData.emails.map((email, i) => i === index ? value : email)
    });
  };

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="inviterName">Your Name</Label>
        <Input
          id="inviterName"
          value={formData.inviterName}
          onChange={(e) => onFormDataChange({ ...formData, inviterName: e.target.value })}
          placeholder="Enter your name"
        />
      </div>

      <div>
        <Label htmlFor="inviterEmail">Your Email</Label>
        <Input
          id="inviterEmail"
          type="email"
          value={formData.inviterEmail}
          onChange={(e) => onFormDataChange({ ...formData, inviterEmail: e.target.value })}
          placeholder="Enter your email"
        />
      </div>

      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label>Friend's Emails</Label>
          {formData.emails.length < 10 && (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={addEmailField}
              className="h-8 px-2"
            >
              <Plus className="h-4 w-4" />
              <span className="ml-1">Add Email</span>
            </Button>
          )}
        </div>
        {formData.emails.map((email, index) => (
          <div key={index} className="flex gap-2">
            <Input
              type="email"
              value={email}
              onChange={(e) => handleEmailChange(index, e.target.value)}
              placeholder="Friend's email"
            />
            {formData.emails.length > 1 && (
              <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={() => removeEmailField(index)}
                className="h-10 w-10"
              >
                <X className="h-4 w-4" />
              </Button>
            )}
          </div>
        ))}
      </div>

      <Button 
        onClick={onSubmit}
        disabled={isProcessing}
        className="w-full"
      >
        {isProcessing ? "Sending..." : "Send Invitations"}
      </Button>
    </div>
  );
};
